import { createAsyncThunk } from "@reduxjs/toolkit";
import { EndPoints } from "../../api/endpoints";
import axiosClient from "../../api/axiosClient";

type FilterQueryParams = {
  from: number;
  to: number;
  atc_id: string;
};

export const getExaminerExamInstances = createAsyncThunk(
  "getExaminerExamInstances",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.examinstances);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

/* `background: true` marks a refresh the examiner did not ask for — the examiner
   screen re-polls this list on a timer so lab and session states do not go stale
   between page loads. The slice keeps the table's loading spinner off for those, so
   a self-refreshing table does not flicker every few seconds. */
export type ScheduleRefreshOptions = { background?: boolean };

export const getExaminerScheduleExamInstances = createAsyncThunk(
  "getExaminerScheduleExamInstances",
  async (
    _options: ScheduleRefreshOptions | undefined,
    { rejectWithValue }
  ): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.examinstancesSchedule);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
export const getUserScheduleExamInstances = createAsyncThunk(
  "getUserScheduleExamInstances",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(
        EndPoints.userExaminstancesSchedule
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const getUserSubmittedExamInstances = createAsyncThunk(
  "getUserSubmittedExamInstances",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(
        EndPoints.userExaminstancesSubmitted
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const filterExaminerExamInstances = createAsyncThunk(
  "filterExaminerExamInstances",
  async (queryParams: FilterQueryParams, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(
        `${EndPoints.examinstances}/filter/?from=${queryParams.from}&to=${queryParams.to}&atc_id=${queryParams.atc_id}`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
